<template>
    <div>
      <!-- <Strong>Rider-Wise OFP Report</Strong> -->

      <b-row class="mt-5">
        <b-col cols="4">
          <b-form-group label="Select Rider"  :label-cols="4" >
            <ejs-multiselect id='multiselect' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
            ></ejs-multiselect>                 
            <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
          </b-form-group>
        </b-col> 
        <b-col cols="4">
          <b-form-group label="From Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="fromDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="To Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="toDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:left;">
          <b-form-group>
            <button class="btn btn-primary" @click="getRiderOFPListing(1)"> Search </button>                       
            <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:right;">
          <b-form-group>
            <button class="btn btn-primary" @click="performanceReport" :disabled="totalRows==0">Download </button>                       
          </b-form-group>
        </b-col>
      </b-row>
      
        <b-row class="my-2">
          <b-col sm="12" class="text-right">
            <b-col sm="12">  
              <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
            </b-col>
          </b-col>  
      
        <b-col sm="12">
          <b-table 
            show-empty 
            stacked="md"
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :bordered="bordered"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
            </div> 

          </b-table>
        </b-col>

        <b-col sm="12" class="my-1 " v-if="this.totalRows > 10">
          <paginate
            v-model="currentPage"
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </b-col> 
      </b-row> 
    </div>
</template>
  
<script>
import CONSTANTS from '@/utils/constants'
  export default {
    data: function(){
      return{
        name: 'riderWiseOFPReport',
        isBusy: false,
        items: [],
        fields: [
          {key:'daname',label:'Driver Name'},
          {key:'created_date',label:'Created Date (DD-MM-YYYY)'},
          {key:'ofp_fresh_shipments',label:'OFP Fresh Shipments'},
          {key:'ofp_pickup_reattempt',label:'OFP Pickup Reattempt'},
          {key:'pickup_exchange',label:'Pickup Exchange'},
          {key:'total_ofp',label:'Total OFP'},
          {key:'ofp_customer_count',label:'OFP Customer Count'},
          {key:'pickup_done_percentage',label:'Pickup Done Percentage'},
          {key:'pickup_cancel_percentage',label:'Pickup Cancel Percentage'},
          {key:'pickup_exchange_percentage',label:'Pickup Exchange Percentage'},
          {key:'pickup_exchange_cancel_percentage',label:'Pickup Exchange Cancel Percentage'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:10,
        searching:'',
        noofpages:'',
        pageNum:1,

        //codCollectionDate:'',
        toDate:new Date(),
        fromDate:new Date(),
        downloadreport:'',
        //isDownloadBtn: true,

        value2:[],
        agentfields: { text: 'name', value: 'id' },
        options: [],
        showSelectAll : true,
        allowCustomValue : true,
      }
    },
    created: function(){
      this.displaydeliveryagent();
      this.getRiderOFPListing(this.pageNum);
    },
    methods:{
      displaydeliveryagent: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        //agentmaster
        const deliveryagent = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
          hub_id:`${userInfo.pickuplocationmasterid}`,
        
        }
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
          .then((result) => {
            //this.getRiderOFPListing(this.pageNum);
            this.agentmaster = result.body;

            for(var i = 0; i < this.agentmaster.length; i++) {
              var deliveryagent2 = {
          name: this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname+" - "+this.agentmaster[i].deliveryagentmasterid,
          id: this.agentmaster[i].deliveryagentmasterid
        }
        this.options.push(deliveryagent2);

          // this.options.push(this.agentmaster[i].deliveryagentfirstname);
            
        }
        // console.log('--------gfg----------');
        // console.log(this.options);
        //        console.log('------------------');

          })
          .catch((ex) => {
            console.log('error', ex)
          })
        },

        getRiderOFPListing: function(page){
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          var hubId = userInfo.pickuplocationmasterid;
          this.isBusy = true;
          var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;

          if(this.fromDate > this.toDate){
            console.log('this.fromDate--->',this.fromDate);
            console.log('this.toDate--->',this.toDate);
            this.$fire({
              text: "From date must be smaller than To date",
              type: "warning",
              timer: 30000
            }); 
          }
          else{
            const Obj = {
              deliveryagentmasterid: deliveryagentidarr,
              fromdate: this.formatDate(this.fromDate),
              todate: this.formatDate(this.toDate), 
              hub_id: hubId
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getRiderwiseOFPPerformanceReport`,Obj)
            .then(result=>{
              if(result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.total_records;
                this.noofpages=parseInt(this.totalRows)/10;
                this.noofpages=Math.round( this.noofpages);
              }
              else{
                this.items = [];
                this.totalRows = 0;
              }
              this.isBusy = false;
            })
            .catch(ex =>{
              console.log('error',ex)
            })
        }
      },

        performanceReport(){
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          var hubId = userInfo.pickuplocationmasterid;
          var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;

          const Obj={
            deliveryagentmasterid: deliveryagentidarr,
            fromdate: this.formatDate(this.fromDate),
            todate: this.formatDate(this.toDate), 
            hub_id: hubId          
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getRiderwiseOFPPerformanceReportCSV`,Obj)
          .then(result=>{
            console.log("response of report--->",result.body);

            if(result.body){
              this.downloadReport(result.body)
            }
            else{
              this.downloadreport='';
            }
          })
          .catch(ex=>{
            console.log('error',ex)
          })
          },

        downloadReport(data){
          const csvData = data
          console.log("Data for download---> ",csvData);
          const anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
          anchor.download = 'riderWiseOFPReport.csv';
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        },

      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      },

      refresh(){
        this.fromDate = new Date();
        this.toDate = new Date();
        this.value2 = [];
        this.getRiderOFPListing(1);
      },

      clickCallback: function(pageNum){
        this.currentPage = pageNum;
        //this.getRiderOFPListing(pageNum);
      },
    }
  };
</script>

<style>

</style>